// extracted by mini-css-extract-plugin
module.exports = {"contact-dealer-btn":"contact-dealer-tooltip_contact-dealer-btn__1Lv8E"};